/** Apply stored or system color scheme before first paint (all entry routes). */
export function applyAdminTheme(): "light" | "dark" {
  if (typeof window === "undefined") {
    return "light";
  }

  const stored = localStorage.getItem("prefers-dark-mode");
  const prefersDark =
    stored != null
      ? stored === "true"
      : window.matchMedia("(prefers-color-scheme: dark)").matches;
  const mode = prefersDark ? "dark" : "light";

  document.documentElement.dataset.theme = mode;
  document.body.style.setProperty("color-scheme", mode);

  return mode;
}
